<template>
  <div class="assign">
    <b-container v-if="isAdmin">
      <b-card>
        <b-card-body>
          Assign categories to species. The data must be in a tsv file (text file with columns
          separated by tabulations). If the category already exists, this will update it.
        </b-card-body>
      </b-card>
      <b-form ref="form" @submit="sendForm">
        <input
          id="file"
          ref="file"
          required
          type="file"
          placeholder="Choose a file or drop it here..."
        />
        <label for="ColumnsInput"
          >Indicate column numbers separated by commas (e.g. 5,7,9). The first columns is the column
          1.</label
        >
        <b-form-input
          id="columnsInput"
          v-model="columns"
          required
          :state="columnsState"
        ></b-form-input>

        <b-form-checkbox v-model="non" value="true" unchecked-value="false" name="checkboxNon">
          Create also the inverse category for each column (e.g AM symbiosys -> non AM symbiosys)
        </b-form-checkbox>

        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>
      <b-alert :show="showMessageSubmit" :variant="variant">{{ messageSubmit }}</b-alert>
    </b-container>
    <b-container v-else>
      <h2>You must be logged as admin to access this function</h2>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Vue from 'vue';

export default {
  data() {
    return {
      file: null,
      columns: '8,9,10,11,12,13,14,15',
      messageSubmit: '',
      variant: 'danger',
      non: false,
    };
  },
  computed: {
    ...mapGetters(['isAdmin', 'getToken', 'getLogin']),
    columnsState() {
      const reg = /^\d+(,\d+)*$/;
      return reg.test(this.columns);
    },
    showMessageSubmit: function() {
      return this.messageSubmit !== '';
    },
  },
  methods: {
    sendForm(evt) {
      evt.preventDefault();

      this.file = this.$refs.file.files[0];

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('columns', this.columns);
      formData.append('login', this.getLogin);
      formData.append('token', this.getToken);
      formData.append('non', this.non);

      if (this.$refs.form.checkValidity()) {
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
          loader: 'dots',
        });
        Vue.http
          .post('api/assignCategories', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(
            resp => {
              if (resp.body == null) {
                this.variant = 'danger';
                this.messageSubmit = 'Server Error';
              } else {
                var success = resp.body.success;
                if (success === false) {
                  this.variant = 'danger';
                } else {
                  this.variant = 'success';
                }
                this.messageSubmit = resp.body.message;
              }
              loader.hide();
            },
            () => {
              this.variant = 'danger';
              this.messageSubmit = 'Server error';
              loader.hide();
            }
          )
          .catch(error => {
            this.variant = 'danger';
            this.messageSubmit = 'Server error (' + error + ')';
            loader.hide();
          });
      }
    },
  },
};
</script>

<style>
.assign {
  margin: 10px auto;
  padding: 5px;
  width: 600px;
}

.card {
  margin: 10px auto;
}
</style>
